<template>
  <div class="stats-pay-methods-container">
    <div class="title">{{ $t('stats_paymethods.title')}}</div>
    <div class="pay-method-container" v-for="(v,k) in stats" :key="k">
      <div class="info-container">
        <div class="label">{{ $t('preorder.payment.'+k) }}</div>
        <div class="label">{{formatNumber(v.sum)}} {{currency.symbol}} <span>| {{v.percentage}}%</span></div>
      </div>
      <div class="percent-container">
        <div
          class="percent-line"
          :style="
            `width:${v.percentage}%;${
              10 == 100 ? '' : 'border-radius:0.4444vh 0 0 0.4444vh'
            } `
          "
        ></div>
      </div>
    </div>
    <!-- <div class="pay-method-container">
      <div class="info-container">
        <div class="label">Картка (термінал)</div>
        <div class="label">9887 ₴</div>
      </div>
      <div class="percent-container">
        <div
          class="percent-line"
          :style="
            `width:${80}%;${
              80 == 100 ? '' : 'border-radius:0.4444vh 0 0 0.4444vh'
            } `
          "
        ></div>
      </div>
    </div>
    <div class="pay-method-container">
      <div class="info-container">
        <div class="label">Картка (онлайн)</div>
        <div class="label">678 ₴</div>
      </div>
      <div class="percent-container">
        <div
          class="percent-line"
          :style="
            `width:${35}%;${
              35 == 100 ? '' : 'border-radius:0.4444vh 0 0 0.4444vh'
            } `
          "
        ></div>
      </div>
    </div>
    <div class="pay-method-container">
      <div class="info-container">
        <div class="label">Бонусний баланс</div>
        <div class="label">200 ₴</div>
      </div>
      <div class="percent-container">
        <div
          class="percent-line"
          :style="
            `width:${20}%;${
              20 == 100 ? '' : 'border-radius:0.4444vh 0 0 0.4444vh'
            } `
          "
        ></div>
      </div>
    </div> -->
  </div>
</template>
<style scoped>
.stats-pay-methods-container {
  background: #e5e5e5;
  border-radius: 1.333vh;
  width: 100%;
  padding: 2.22vh;
  margin-top: 3.3333333333333335vh;
  box-sizing: border-box;
}
.title {
  font-size: 2.7777777777777777vh;
  line-height: 3.2222222222222223vh;
  color: #908f8d;
  margin-bottom: 2.222vh;
}
.pay-method-container {
  width: 100%;
  margin-top: 2.222vh;
}
.pay-method-container:first-child {
  margin-top: 0;
}
.label {
  font-size: 2.22vh;
  line-height: 2.5555555555555554vh;
  color: #129b81;
}
.label span {
  color: #908f8d;
}
.info-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.percent-container {
  width: 100%;
  margin-top: 1.111vh;
  background: #d2d2d2;
  height: 1.6666666666666667vh;
  border-radius: 0.4444444444444444vh;
}
.percent-line {
  margin-top: 1.111vh;
  background: #129b81;
  height: 1.6666666666666667vh;
  border-radius: 0.4444vh;
}
</style>

<script>
export default {
  props: {
    stats: Object
  },
  computed:{
    currency() {
      return this.$store.state.currency;
    }
  },
  methods: {
    formatNumber(raw) {
      if (!raw || isNaN(raw)) return 0;

      return (+raw).toFixed(2); 
    }
  }
}
</script>